import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from "@angular/common/http";
import { GlobalConstants } from "./constants";

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const creds = localStorage.getItem("authCreds");
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Basic ${creds}`,
      },
    });

    return next.handle(clonedReq);
  }
}
